var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-divider",class:[{'menu-divider-border': _vm.border, 'menu-divider-large': _vm.large, 'menu-divider-inset': _vm.inset}]})}
var staticRenderFns = []

export { render, staticRenderFns }